import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import ROUTES from '@CONSTANTS/ROUTES.constant';

import { useDeleteChapter } from '@SERVICES';
import useDeleteChapterModal from '@HOOKS/store/modals/useDeleteChapterModal';

import DeleteItemModal from '@MODALS/common/DeleteItemModal';

function DeleteChapterModal() {
    const navigate = useNavigate();
    
    const {
        state: { data: modalParams },
        actions,
    } = useDeleteChapterModal();

    const [
        deleteChapter,
        {
            isLoading, isSuccess, isError, error,
        },
    ] = useDeleteChapter();

    // Navigate to document page after successful deletion
    useEffect(() => {
        if (isSuccess) {
            navigate(ROUTES.admin.documents.id.get(modalParams!.documentId));
        }
    }, [isSuccess, navigate, modalParams]);

    return (
        <DeleteItemModal
            modalTitle="Delete chapter"
            name={modalParams!.name}
            itemName="Chapter"
            description="All sections of this chapter will also be deleted!"
            isLoading={isLoading}
            isSuccess={isSuccess}
            isError={isError}
            error={error}
            onDelete={() => {
                deleteChapter({
                    id: modalParams!.id,
                    documentId: modalParams!.documentId,
                });
            }}
            onClose={() => {
                actions.close();
            }}
        />
    );
}

export default DeleteChapterModal;
